import { LeadCandidate } from "@inrange/building-manager-api-client";

// Opening a search row stamps it Viewed - but only a VOA row has that field. An
// existing-site row's sourceRef is a site id the VOA endpoint can't find (ADMIN-APP-53).
export const needsViewedStamp = (
  candidate: Pick<LeadCandidate, "source" | "reviewedAt">
): boolean => candidate.source === "voa" && !candidate.reviewedAt;
